import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ElementRef, HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {
  componentDestroyed,
  Tournament, TournamentDivision,
  TournamentGender,
  TournamentStatuses,
  TournamentTeam,
  UntilDestroy
} from '@mtgame/core';
import { getTeamPageRoute, getTournamentRoute } from '@config/routes';
import { LeagueTournamentService } from './league-tournament.service';
import { filter, take, takeUntil } from 'rxjs/operators';
import { ViewportService } from '@core/services/viewport.service';

@UntilDestroy
@Component({
  selector: 'mtg-league-tournament-card',
  templateUrl: './league-tournament-card.component.html',
  styleUrls: ['./league-tournament-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    LeagueTournamentService,
  ]
})
export class LeagueTournamentCardComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  tournament: Tournament;
  teamsByDivision: {[key: number]: TournamentTeam[]} = {};
  divisions: TournamentDivision[] = [];

  tournamentRoute: string[];
  loading: boolean;

  constructor(
    private leagueTournamentService: LeagueTournamentService,
    private viewportService: ViewportService,
    private elementRef: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {
  }

  async ngOnInit() {
    this.loading = true;
    this.tournamentRoute = getTournamentRoute(this.tournament.alias);

    this.leagueTournamentService.divisions$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(divisions => {
        this.divisions = divisions;
        this.cdr.markForCheck();
      })
    this.leagueTournamentService.teams$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(teams => {
        this.teamsByDivision = teams.reduce((acc, item) => ({
          ...acc,
          [item.division.id]: [
            ...(acc[item.division.id] || []),
            item
          ]
        }), {});
        this.cdr.markForCheck();
      })
  }

  ngAfterViewInit() {
    this.viewportService.track(this.elementRef.nativeElement)
      .pipe(
        filter(value => Boolean(value)),
        takeUntil(componentDestroyed(this)),
        take(1)
      ).subscribe(async () => {
        await this.leagueTournamentService.initialize(this.tournament);
          this.loading = false;
        });
  }

  ngOnDestroy() {
    this.leagueTournamentService.dispose();
    this.viewportService.deleteElement(this.elementRef.nativeElement);
  }
}
